export default "__VITE_ASSET__af01d4dd__"